/**
 * A facade for BodyColumns.js
 * NOTE: this is purposefully ***not*** using jQuery to calculate the
 * body column count.
 * NOTE 2: This should only be used by Viewport.js. If you need to update the
 * number of columns, see Viewport.js.
 */
const BodyColumns = {
  /**
   * Get the body width -- used to determine how many columns should be
   * displayed. This is a separate method for ease of testing.
   *
   * The documentElement.clientWidth clause is needed for IE8.
   * Window.innerWidth will include the scroll bars if present, thus
   * has the lowest priority.
   * This method assumes that the body is the same size as the
   * documentElement, i.e. it hasn't been assigned styles as the script
   * is executed before the body is added.
   *
   * @return {number} The width of the body, in pixels
   */
  getBodyWidth() {
    return document.documentElement.clientWidth || window.innerWidth;
  },

  /**
   * Determine the number of columns needed to fill the body.
   *
   * @return {number} The number of columns in a body
   */
  getBodyColumnsNeeded() {
    const columnWidth = 236 + 14;
    const bodyWidth = BodyColumns.getBodyWidth();
    return Math.min(Math.max(Math.floor(bodyWidth / columnWidth), 3), 10);
  },

  /**
   * Set the proper classname on the documentElement. The classname
   * (columns-N) will correspond to CSS rules that lays out the grid.
   *
   * @param {number=} columnCount something
   */
  setNumColumns(columnCount) {
    const documentElement = document.documentElement;
    let numColumns;

    if (columnCount) {
      numColumns = columnCount;
    } else {
      numColumns = BodyColumns.getBodyColumnsNeeded();
    }
    const oldDocClassName = documentElement.className;
    const noColDocClassName = oldDocClassName.replace(/ columns-\d+/, '');
    const colClassName = ' columns-' + numColumns;
    const newClassName = noColDocClassName + colClassName;
    documentElement.className = newClassName;
  },
};

export default BodyColumns;
